import React from "react";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useRef } from "react";
import SignatureCanvas from 'react-signature-canvas';
import { Link } from "react-router-dom";
import Loading from "./Loading";
import userPlaceholder from '../../../resources/img/user-default.jpg';

function Perfil2(props) {

    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [mensajePopup, setMensajePopup] = useState('Lorem ipsum dolor');
    const [claseMensajePopup, setClaseMensajePopup] = useState('alert alert-success mensaje-popup');
    const [uid, setUid] = useState();

    const [btnstate, setBtnstate] = useState(true);

    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [agendas, setAgendas] = useState([]);
    const [agendaFavorita, setAgendaFavorita] = useState('');

    const [imagedata, setImagedata] = useState('');
    const [imgperfildata, setImgperfildata] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [perfilimg, setPerfilimg] = useState('/smile/dist/img/user-default.jpg');
    const [perfil, setPerfil] = useState('/smile/dist/img/user-default.jpg');
    const [firmablob, setFirmablob] = useState('');

    const canvasRef = useRef(0);

    let userdata = [];
    let clientData = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setUid(userdata.user_id);
        }
    
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }    
    
        axios.get('/especialidades?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            })
        
        axios.get('/agendas-usuario', config)
            .then(response => {
                if (response.status === 200) {
                    setAgendas(response.data);
                }
            })
            .catch(error => {
                console.log('Error loading agendas:', error);
            });
        
    
        axios.get('/perfil?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombre(response.data.name+' '+response.data.lastname);
                    setEmail(response.data.email);
                    setDescripcion(response.data.descripcion);
                    setEspecialidad(response.data.especialidad);
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    //setFirmaimg(response.data.firma);
                    setFirmablob(response.data.firma_blob);
                    
                    if (response.data.imagen_perfil!=null) {
                        setPerfilimg(response.data.imagen_perfil);
                    }

                    if (response.data.firma_blob) {
                        canvasRef.current.fromDataURL(response.data.firma_blob);
                    }

                    if (response.data.agenda_favorita) {
                        setAgendaFavorita(response.data.agenda_favorita);
                    }
                    
                }
            })
            .catch(error => {
                console.log(error);
            });

    },[]);



    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            uid: userdata.user_id,
            email: email,
            descripcion: descripcion,
            especialidad: especialidad,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            agenda_favorita: agendaFavorita
        }

        if (!canvasRef.current.isEmpty()) {
            conf.firma_blob = canvasRef.current.toDataURL('image/png');
            userdata.firma = true;
        }

        if (imgperfildata) {
            const formData = new FormData();

            formData.append('image', imgperfildata);
            formData.append('id', uid);

            axios.post('/fotoperfil',formData)
                .then((res) => {
                    if (res.status===200) {
                        userdata.firma = true;
                        setPerfilimg(res.data.url);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }

        axios.put('/perfil', conf)
            .then(
                response => {
                    setLoading(false);
                    userdata.registro = registroMedico;
                    userdata.codigo_habilitacion = codigoHabilitacion;
                    userdata.agenda_favorita = agendaFavorita;

                    localStorage.setItem('userdata',JSON.stringify(userdata));
                    props.toastMsg('Se ha actualizado la información de tu perfil');
                }
            )
            .catch(
                err => {
                    console.log(err.response.data);
                    setLoading(false);
                }
            )
    }

    

    const handleChange = (file) => {
        setImagedata(file[0]);

        const f = URL.createObjectURL(file[0]);
        setFirmaimg(f);
    }

    const agregarFotoPerfil = (file) => {
        setImgperfildata(file[0]);

        const f = URL.createObjectURL(file[0]);
        setPerfilimg(f);
    }

    return (
            
                <section className="content" >
                    <div className="container-fluid">

                        
                        <div className="row">

                            <div className="profile-imgs">
                                <div className="profile-img-container">
                                    <img src={perfilimg} className="profile-img" />
                                    <input type="file" name="perfilimg" id="perfilimg" className="form-control profile-img-control" onChange={(e) => agregarFotoPerfil(e.target.files)} />
                                </div>
                                <label htmlFor="perfilimg" className="lbl-cargar-foto-perfil">Cargar imagen</label>
                                <label htmlFor="companyName">Firma</label>
                                <br></br>

                                <SignatureCanvas ref={canvasRef} penColor='#242424' canvasProps={{width: 330, height: 130, className: 'sigCanvas', style:{border:'1px solid'}}} />
                                <br />
                                <button className="btn btn-primary btn-sm" onClick={(e) => { e.preventDefault(); canvasRef.current.clear(); }}><i className="fas fa-eraser"></i> Borrar</button>&nbsp;

                            </div>

                            <div className="col-md-5">
                                
                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                                    <div className="form-group">
                                        <label htmlFor="nombre">Nombre</label>
                                        <p>{nombre}</p>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="companyName">Email</label>
                                        <input type="email" name="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="descripcion">Descripción corta</label>
                                        <input type="text" name="descripcion" className="form-control" id="descripcion" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="especialidad">Especialidad</label>
                                        <select className="form-control" name="especialidad" id="especialidad" value={especialidad} onChange={(e) => setEspecialidad(e.target.value)}>
                                            <option value={''}>Ninguna</option>
                                            {
                                                especialidades.map((esp) => 
                                                    <option key={'e'+esp.id} value={esp.id}>{esp.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="registro-medico">Registro médico</label>
                                        <input type="text" name="registro-medico" className="form-control" id="registro-medico" value={registroMedico} onChange={(e) => setRegistroMedico(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="agenda-favorita"><i className="fas fa-calendar-alt mr-1"></i> Mi agenda (Predeterminada)</label>
                                        <select 
                                            className="form-control" 
                                            name="agenda-favorita" 
                                            id="agenda-favorita" 
                                            value={agendaFavorita} 
                                            onChange={(e) => setAgendaFavorita(e.target.value)}
                                        >
                                            <option value={''}>Ninguna (Mostrar todas)</option>
                                            {
                                                agendas.map((ag) => 
                                                    <option key={'ag'+ag.id} value={ag.id}>{ag.nombre}</option>
                                                )
                                            }
                                        </select>
                                        <small className="form-text text-muted">
                                            Selecciona la agenda que deseas ver por defecto al abrir el módulo de agenda.
                                        </small>
                                    </div>
                                    <div className="form-group">
                                        

                                    </div>

                                    <div className="form-group">
                                        <button type="submit" id="btn-submit" className="btn btn-primary">Guardar cambios</button>
                                    </div>
                                </form>
                                
                            </div>

                        </div>
                    </div>
                </section>
            
        );
}
export default Perfil2;